// extracted by mini-css-extract-plugin
module.exports = {"answer":"AnswerBox_answer__2vc7n","name":"AnswerBox_name__38cMf"};